/* EYESHELLS 1686: per-history-entry Collection/Search return positions.
   Native restoration stays enabled. This bounded correction handles AJAX/layout
   changes; it never hides the page or keeps moving it after user interaction. */
(function (w, d) {
  'use strict';
  if (w.ESBrowseHistory) return;
  try { w.history.scrollRestoration = 'auto'; } catch (e) {}
  var KEY = 'esBrowsePositions.v1';
  var STATE_KEY = 'esBrowsePosition';
  var MAX_AGE = 6 * 60 * 60 * 1000;
  var records = {};
  var active = null;
  var ready = true;
  var suspended = false;
  var saveTimer = null;
  var restoreTimers = [];
  var restoring = null;
  var generation = 0;
  var layoutWidth = viewportWidth();
  var listing = !!(d.body && /\btemplate-(collection|search)\b/.test(d.body.className));

  function viewportWidth() { return Math.round(d.documentElement.clientWidth || w.innerWidth || 0); }
  function href() { return w.location.pathname + w.location.search + w.location.hash; }
  function number(value) { return typeof value === 'number' && isFinite(value) ? value : 0; }
  function valid(value) {
    return !!(value && typeof value.id === 'string' && typeof value.href === 'string' &&
      typeof value.ts === 'number' && Date.now() - value.ts < MAX_AGE && value.ts <= Date.now());
  }
  if (listing) {
    try { records = JSON.parse(w.sessionStorage.getItem(KEY)) || {}; } catch (e) {}
  }
  if (!records || typeof records !== 'object' || Array.isArray(records)) records = {};

  function persist() {
    var entries = Object.keys(records).filter(function (id) { return valid(records[id]); });
    entries.sort(function (a, b) { return records[b].ts - records[a].ts; });
    var kept = {};
    entries.slice(0, 30).forEach(function (id) { kept[id] = records[id]; });
    records = kept;
    try { w.sessionStorage.setItem(KEY, JSON.stringify(records)); } catch (e) {}
  }
  function read(state) {
    var saved = state && state[STATE_KEY];
    if (!valid(saved) || saved.href !== href()) return null;
    var cached = records[saved.id];
    return valid(cached) && cached.href === saved.href && cached.ts >= saved.ts ? cached : saved;
  }
  function fresh() {
    return { id: Date.now().toString(36) + '-' + Math.random().toString(36).slice(2), href: href(), ts: Date.now(), x: 0, y: 0 };
  }
  function writeHistory(value) {
    try {
      var state = Object.assign({}, w.history.state || {});
      state[STATE_KEY] = value;
      w.history.replaceState(state, '', w.location.href);
    } catch (e) {}
  }
  function position() {
    var y = number(w.pageYOffset);
    // Search now keeps the body in normal flow. Use the real scroll position;
    // only older fixed-body locks supply an explicit negative lock offset.
    if (d.documentElement.classList.contains('es-search-modal-open')) {
      var legacyTop = parseFloat(d.documentElement.style.getPropertyValue('--es-search-lock-top'));
      if (isFinite(legacyTop)) y = -legacyTop;
    } else if (d.body && d.body.style.position === 'fixed') {
      y = -(parseFloat(d.body.style.top) || 0);
    }
    return { x: Math.max(0, number(w.pageXOffset)), y: Math.max(0, y) };
  }
  function anchorAtViewport() {
    if (!d.elementFromPoint) return null;
    var widths = [0.25, 0.5, 0.75];
    for (var i = 0; i < widths.length; i += 1) {
      var node = d.elementFromPoint(w.innerWidth * widths[i], Math.min(w.innerHeight * 0.4, 320));
      var card = node && node.closest && node.closest('[data-es-product-card][data-es-product-id]');
      if (!card || !card.closest('.es-collection-grid-item')) continue;
      return { id: card.getAttribute('data-es-product-id'), top: card.getBoundingClientRect().top };
    }
    return null;
  }
  function remember(updateHistory) {
    if (!listing || !active || !ready || suspended || restoring || viewportWidth() !== layoutWidth) return;
    // A popstate already exposes the destination entry. Keep the outgoing
    // position under its own ID; never overwrite the destination's history.state.
    var point = position();
    active = Object.assign({}, active, point, {
      ts: Date.now(), anchor: point.y === number(w.pageYOffset) ? anchorAtViewport() : null
    });
    records[active.id] = active;
    if (updateHistory && active.href === href()) writeHistory(active);
  }
  function clearSaveTimer() {
    w.clearTimeout(saveTimer);
    saveTimer = null;
  }
  function cancel() {
    generation += 1;
    restoreTimers.forEach(function (timer) { w.clearTimeout(timer); });
    restoreTimers = [];
    restoring = null;
  }
  function applyPoint() {
    if (!restoring || suspended || !ready) return;
    if (d.documentElement.classList.contains('es-search-modal-open') || (d.body && d.body.style.position === 'fixed')) return;
    var point = restoring.point;
    if (restoring.href !== href()) { cancel(); return; }
    var y = Math.max(0, number(point.y));
    if (point.anchor && /^\d+$/.test(point.anchor.id)) {
      var card = d.querySelector('.es-collection-grid-item [data-es-product-card][data-es-product-id="' + point.anchor.id + '"]');
      if (card && card.getBoundingClientRect().height > 0) {
        y = Math.max(0, w.pageYOffset + card.getBoundingClientRect().top - number(point.anchor.top));
      }
    }
    if (Math.abs(w.pageYOffset - y) <= 1 && Math.abs(w.pageXOffset - number(point.x)) <= 1) return;
    var style = d.documentElement.style;
    var previous = style.getPropertyValue('scroll-behavior');
    var priority = style.getPropertyPriority('scroll-behavior');
    style.setProperty('scroll-behavior', 'auto', 'important');
    try { w.scrollTo(Math.max(0, number(point.x)), y); }
    finally {
      if (previous) style.setProperty('scroll-behavior', previous, priority);
      else style.removeProperty('scroll-behavior');
    }
  }
  function restore(point, widthChange) {
    cancel();
    if (!point || suspended) return;
    restoring = { point: point, href: href() };
    var ticket = generation;
    // Initial DOM, deferred search ranking, images/fonts and content-visibility
    // can settle at different times. History retries stop after two seconds;
    // an in-page width change settles in 320ms. Both stop immediately on input.
    (widthChange ? [0, 80, 220] : [0, 80, 220, 520, 1000, 1800]).forEach(function (delay) {
      restoreTimers.push(w.setTimeout(function () {
        if (generation === ticket) applyPoint();
      }, delay));
    });
    restoreTimers.push(w.setTimeout(function () {
      if (generation !== ticket) return;
      cancel();
      remember(true);
    }, widthChange ? 320 : 2000));
  }
  function save() {
    clearSaveTimer();
    if (!listing) return;
    // A link/pagehide can arrive during the bounded layout correction. Save
    // what the customer actually sees, not the older pre-toggle position.
    if (restoring) cancel();
    remember(true);
    persist();
  }
  function captureLayout() {
    if (!listing || !ready || suspended) return null;
    var grid = d.querySelector('.es-collection-grid-row');
    // Above the results, leave the heading and toolbar in their normal place.
    if (!grid || grid.getBoundingClientRect().top >= 0) return null;
    clearSaveTimer();
    cancel();
    var point = position();
    point.anchor = anchorAtViewport();
    return point.anchor ? point : null;
  }
  function restoreLayout(point) {
    if (!point || !ready || suspended) return;
    restore(point, true);
    // The class/column changes are synchronous; correct before the next paint.
    applyPoint();
  }
  function hold() { clearSaveTimer(); cancel(); ready = false; return generation; }
  function commit(point, ticket) {
    ready = true;
    active = read(w.history.state) || fresh();
    if (point && (ticket === undefined || ticket === generation)) restore(point);
    else remember(true);
  }

  w.ESBrowseHistory = {
    save: save, hold: hold, commit: commit, restore: restore, cancel: cancel, position: position,
    captureLayout: captureLayout, restoreLayout: restoreLayout,
    target: function () { return read(w.history.state); }
  };

  function userIntent(event) {
    if (event.type === 'keydown' && !/^(ArrowUp|ArrowDown|PageUp|PageDown|Home|End| |Tab)$/.test(event.key)) return;
    cancel();
    initialPoint = null;
  }
  ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (type) {
    w.addEventListener(type, userIntent, { capture: true, passive: true });
  });
  w.addEventListener('pagehide', function () {
    save();
    suspended = true;
    cancel();
  });
  if (!listing) {
    w.addEventListener('pageshow', function () { suspended = false; });
    return;
  }

  var initialPoint = read(w.history.state);
  active = initialPoint || fresh();
  writeHistory(active);
  // Width changes reflow the grid. Retain the last visible product instead of
  // its old absolute Y. Height-only toolbar/keyboard changes do not move it.
  w.addEventListener('resize', function () {
    var nextWidth = viewportWidth();
    if (nextWidth === layoutWidth) return;
    layoutWidth = nextWidth;
    clearSaveTimer();
    if (!ready || suspended || !active || active.href !== href()) return;
    if (restoring) return; // The existing history correction already tracks its anchor.
    if (d.documentElement.classList.contains('es-search-modal-open') ||
        d.documentElement.classList.contains('es-mobile-filters-open') ||
        (d.body && d.body.style.position === 'fixed')) return;
    if (!active.anchor) return;
    var point = Object.assign({}, active, { anchor: Object.assign({}, active.anchor) });
    point.anchor.top = Math.min(number(point.anchor.top), Math.max(0, w.innerHeight * 0.4));
    restore(point, true);
  }, { passive: true });
  w.addEventListener('scroll', function () {
    if (!ready || suspended || restoring) return;
    clearSaveTimer();
    saveTimer = w.setTimeout(function () { saveTimer = null; remember(true); }, 180);
  }, { passive: true });
  d.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('a[href]');
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) save();
  }, true);
  d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'hidden') save(); });
  w.addEventListener('popstate', function () {
    clearSaveTimer();
    remember(false);
    persist();
    cancel();
    active = read(w.history.state) || fresh();
    // Collection's owner first reconciles the requested filter/page HTML.
    // Search uses normal document navigation and needs no AJAX reconciliation.
    if (!d.querySelector('.collection-page-fullwidth')) restore(read(w.history.state));
  });
  w.addEventListener('pageshow', function (event) {
    suspended = false;
    if (event.persisted) ready = true;
    var point = event.persisted ? read(w.history.state) : initialPoint;
    initialPoint = null;
    if (point && point.href !== href()) point = null;
    if (point) active = point;
    if (point) restore(point);
  });
  d.addEventListener('es:search:ranked', applyPoint);
})(window, document);
